export const WINDOW_OPTIONS = [24, 72] as const;
export type WindowHours = (typeof WINDOW_OPTIONS)[number];

export function windowFromParam(value: string | null): WindowHours {
  return value === '72' ? 72 : 24;
}

